


































import { Vue, Component, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { CreateElement, RenderContext } from "vue";

@Component
export default class UGridItem extends Vue {
  // Props

  @Prop({ default: "router-link" })
  public readonly tag!: string;

  @Prop({ required: true })
  public readonly action!: string | TranslateResult;

  @Prop({ default: false })
  public readonly isLoading!: boolean;

  // Computed

  public get hasSkeletons() {
    return !!this.$slots?.skeletons;
  }

  public get component() {
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) => {
        if (this.hasSkeletons)
          return h("a", { class: "u-grid-item" }, children);
        return h(
          this.tag,
          {
            class: "u-grid-item is-clickable",
            props: this.$attrs,
            on: this.$listeners
          },
          children
        );
      }
    };
  }
}
